import React from "react";

export function A11yAnnouncer(): JSX.Element {
  return (
    <>
      <div aria-live="polite" role="status" className="sr-only" id="a11y-polite" />
      <div aria-live="assertive" role="alert" className="sr-only" id="a11y-assertive" />
    </>
  );
}
